(function() {
  'use strict';

  angular.module('component.files', []);
})();
